import { getHTMLTextContent } from '@/lib/util';
import { ChoiceMetadataType } from '@/modules/types/choice';
import { QuizQuestion } from '@/modules/types/question';
import { FormItem, Radio, TextArea } from 'elmo-elements';
import React, { useEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

export const TrafficChoice = (): React.ReactElement => {
  const labels = ['Red', 'Amber', 'Green'];

  const {
    formState: { errors },
    control,
    getValues,
    watch,
    setValue,
    register,
  } = useFormContext<QuizQuestion>();
  const {
    fields: choicesFields,
    remove,
    append,
  } = useFieldArray({
    name: 'choices',
    control,
  });

  useEffect(() => {
    if (!getValues('choices') || getValues('choices')?.length === 0) {
      remove();

      for (let index = 0; index < labels.length; index += 1) {
        append({
          content: '',
          position: index,
          isCorrect: false,
          type: ChoiceMetadataType.main,
        });
      }
    }
  }, [append, getValues, labels.length, remove]);

  const handleChange = (key: any, value: any) => {
    setValue(key, value);
  };

  return (
    <div className="choice-group">
      {choicesFields.map((choiceField, index) => (
        <FormItem
          label={labels[index]}
          key={choiceField.id}
          message={errors.choices?.[index]?.content?.message}
          status={errors.choices?.[index]?.content ? 'error' : 'default'}
        >
          <div className="traffic">
            <Radio
              value={choiceField.id}
              {...register(`choices.${index}.id`, {})}
              onChange={(e) => {
                choicesFields.forEach((choice, i) => {
                  choice.isCorrect = e === choice?.id;

                  handleChange(`choices.${i}.isCorrect`, e === choice.id);
                });
              }}
              name={`choices.${index}.id`}
              checked={watch(`choices.${index}.isCorrect`)}
            />
            <TextArea
              value={
                getHTMLTextContent(watch(`choices.${index}.content`)) ?? ''
              }
              {...register(`choices.${index}.content`, {})}
              onChange={(e: any) =>
                handleChange(`choices.${index}.content`, e.target.value)
              }
              name={`choices.${index}.content`}
              ariaLabel={`Choice ${index}`}
              id={`elearning-choice-${index}`}
              placeholder={`Enter ${labels[index]} traffic description`}
            />
          </div>
        </FormItem>
      ))}
    </div>
  );
};

export default TrafficChoice;
